import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { getStrDate } from "../../../../global/utils/diasData";
import IconBlack from "../../../assets/images/generico/IconBack";
import HeaderTimer from "../../Genericos/HeaderTimer/HeaderTimer";
import DatePicker from "../../Genericos/DatePicker/DatePicker";
import DropdownCheck from "../../Genericos/DropdownCheck/DropdownCheck";
import isIosNative from "../../../../global/utils/isIosNative";
import "./HeaderBarFiltrosPcr.css";
import { HeaderBarFiltrosPcrContainer } from "./localStyle";

const HeaderBarFiltrosPcr = ({
  handleClickVolver,
  handleChangeDatePicker,
  fecha,
  handleChangeCentros,
  handleChangeDia,
  handleChangeRango,
  handleChangeEspecialista,
  turnosData,
  filtrosData,
}) => {
  const { turnosDisponiblesState } = useContext(PortalContext);
  const [centrosInicial, setCentrosInicial] = useState(1);

  useEffect(() => {
    if (turnosData !== null) {
      if (turnosData.length > 0) {
        let centro = [...new Set(turnosData.map((item) => item.centro))];
        const map = new Map();
        for (const item of centro) {
          if (
            !filtrosData.centros.filter((x) => x.descripcion === item).length >
            0
          ) {
            if (!map.has(item)) {
              map.set(item);
              //para colocar correctamente los id. tomo el ultimo item de la lista. cuyo id + 1.
              const lastItem =
                filtrosData.centros[filtrosData.centros.length - 1];
              filtrosData.centros.push({
                id: lastItem.id + 1,
                descripcion: item,
                checked: false,
              });
            }
            if (filtrosData.centros.length >= 2) {
              setCentrosInicial(filtrosData.centros.length - 1);
            }
          }
        }
      } else if (turnosData.length === 0 && filtrosData.centros.length < 2) {
        setCentrosInicial(0);
      }
    }
  }, [turnosData]);

  const hoyDia = new Date();
  const noventaDiasDespues = new Date();
  noventaDiasDespues.setDate(noventaDiasDespues.getDate() + 90);
  const diaSelecionado =
    turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada;
  const [iosInfo, setIosInfo] = useState(false);
  async function infoIos() {
    const isIosNativeMobile = await isIosNative.logDeviceInfo();
    setIosInfo(isIosNativeMobile);
    return isIosNativeMobile;
  }
  infoIos();
  return (
    <React.Fragment>
      <HeaderBarFiltrosPcrContainer className="c-white" isIos={iosInfo}>
        <div className="ptur-headerbarFiltros-volverBox">
          <button
            className="ptur-headerbarFiltros-volverBtn"
            onClick={handleClickVolver}
          >
            <IconBlack />
            <span className="ptur-headerbarFiltros-volverTxt rb18m">
              VOLVER
            </span>
          </button>
        </div>
        <div className="ptur-headerBarFiltros-filtros c-white">
          <div className="ptur-headerBarFiltros-filtros-title">
            <span className="rb18m">Filtros:</span>
          </div>
          <div className="ptur-headerBarFiltros-filtros-centro c-black">
            <DropdownCheck
              customWh={"ptur-headerBarFiltros-centroCheck-box"}
              boxCheckArrowed={false}
              handleChangeFiltros={handleChangeCentros}
              placeholder={"Centros"}
              longitud={centrosInicial}
              datos={filtrosData?.centros}
            />
          </div>
          <div className="ptur-headerBarFiltrosPcr-filtros-fecha c-black">
            <DatePicker
              fechaInicial={`${hoyDia.getFullYear()} ${
                hoyDia.getMonth() + 1
              } ${hoyDia.getDate()}`}
              fechaFinal={`${noventaDiasDespues.getFullYear()} ${
                noventaDiasDespues.getMonth() + 1
              } ${noventaDiasDespues.getDate()}`}
              // fechaMin={fecha}
              selectedFecha={`${!diaSelecionado ? "" : diaSelecionado}`}
              onChange={handleChangeDatePicker}
              customCss={"ptur-headerBarFiltros-filtros-datePicker-4268"}
            />
          </div>
          <div className="ptur-headerBarFiltros-filtros-dia c-black">
            <DropdownCheck
              customWh={"ptur-headerBarFiltros-diaCheck-box"}
              boxCheckArrowed={false}
              placeholder={"Día semanal"}
              longitud={filtrosData?.diasKin.length}
              datos={filtrosData?.diasKin}
              handleChangeFiltros={handleChangeDia}
            />
          </div>
          <div className="ptur-headerBarFiltros-filtros-hora c-black">
            <DropdownCheck
              customWh={"ptur-headerBarFiltros-rangoCheck-box"}
              boxCheckArrowed={false}
              placeholder={"Horarios"}
              longitud={filtrosData?.rangoHorario.length}
              datos={filtrosData?.rangoHorario}
              handleChangeFiltros={handleChangeRango}
            />
          </div>
        </div>
        <div className="ptur-headerBarFiltros-txtDiaHora">
          <p id="ptur-DiaResponsive" className="rb18m">
            {getStrDate(new Date())}
            <span className="ptur-timer">
              <HeaderTimer />
            </span>
          </p>
        </div>
      </HeaderBarFiltrosPcrContainer>
      <div
        className={
          iosInfo
            ? "ptur-headerbarFiltros-container c-white iosMobileStatusBarFix"
            : "ptur-headerbarFiltros-container c-white"
        }
      ></div>
    </React.Fragment>
  );
};

export default HeaderBarFiltrosPcr;
